export const BRAND = {
  primary: "#1B723B",
  primaryDark: "#124B28",
  primaryGlow: "rgba(27,114,59,0.45)",
  ink: "#070708",
  white: "#FFFFFF",
  ac: "#1B723B",
  dcFast: "#0E7AB8",
  dcUltra: "#6E3FB8",
  statusAvailable: "#1B723B",
  statusCharging: "#D69E0A",
  statusOutOfOrder: "#C0392B",
  statusUnknown: "#7A7A82",
} as const;
